export const AnalyticEvent = {
  // Customer
  Payment: {
    Success: "Payment.Success",
    Failure: "Payment.Failure",
  },
  Reservation: {
    Accepted: "Reservation.Accepted",
    ChangeDate: "Reservation.ChangeDate",
    ChangeServiceDetails: "Reservation.ChangeServiceDetails",
    CouponUsed: "Reservation.CouponUsed",
    DeleteService: "Reservation.DeleteService",
    Failure: "Reservation.Failure",
    OneTime: "Reservation.OneTime",
    Periodicity: "Reservation.Periodicity",
    Start: "Reservation.Start",
    Subscription: "Reservation.Subscription",
    Success: "Reservation.Success",
    Summary: "Reservation.Summary",
    View: "Reservation.View",
  },
  User: {
    HomeSize: "User.HomeSize",
    LastOrder: "User.LastOrder",
    LastOrderType: "User.LastOrderType",
    LastSeen: "User.LastSeen",
    Onboarding: "User.Onboarding",
    PostalCode: "User.PostalCode",
    Voucher: "Reservation.Voucher",
    CreditBalance: "User.CreditBalance",
  },

  // Common
  Register: {
    Details: "Register.Details",
    Start: "Register.Start",
    Success: "Register.Success",
    Failure: "Register.Failure",
  },
  Login: {
    Start: "Login.Start",
    Success: "Login.Success",
    Failure: "Login.Failure",
    Social: {
      Google: "Login.Social.Google",
      Facebook: "Login.Social.Facebook",
      Apple: "Login.Social.Apple",
    },
  },
  Review: {
    Bad: "Review.Bad",
    Good: "Review.Good",
  },

  // GTM events
  GTM: {
    Affiliate: "affiliate",
    AddToCart: "add_to_cart",
    InitiateCheckout: "initiate_checkout",
    Login: "login",
    Purchase: "purchase",
    Subscription: "subscription",
    SignUp: "sign_up",
    ViewItem: "view_item",
  },

  // CustomerIO events
  CustomerIO: {
    PushReceived: "CustomerIO.PushReceived",
    PushFailed: "CustomerIO.PushFailed",
  },
} as const;

type PathImpl<T, K extends keyof T> = K extends string
  ? T[K] extends Record<string, ToDo>
    ? T[K] extends ArrayLike<ToDo>
      ? K | `${K}.${PathImpl<T[K], Exclude<keyof T[K], keyof ToDo[]>>}`
      : K | `${K}.${PathImpl<T[K], keyof T[K]>}`
    : K
  : never;

export type Path<T> = PathImpl<T, keyof T> | keyof T;
